<template>
	<label
		class="w-100 mb-4 pointer structure-item"
		:for="optionName"
	>
		<input
			:id="optionName"
			:aria-checked="ariaCheckedValue"
			:name="groupName"
			type="radio"
			:value="item.value"
			@blur="focused = false"
			@click="emitEvent"
			@focus="focused = true"
			@keyup.space="emitEvent"
		>

		<span
			class="d-flex flex-column w-100 pa-4 rounded hover-style"
			:class="checked ? 'ap-blue lighten-3 selected-border' : 'ap-grey lighten-4'"
			:style="focusStyle"
		>
			<span
				v-if="item.defaultStructure"
				class="d-block d-md-none align-self-end ap-blue--text text--darken-1 font-weight-semibold"
			>
				{{ locales.defaultStructure }}
			</span>

			<span class="d-flex align-md-center">
				<AmeliproIcon
					bordered
					class="mr-4"
					icon="localisation"
					icon-bg-color="ap-white"
					icon-color="#01B9F5"
					x-large
				/>

				<span class="w-100 d-flex flex-column flex-md-row justify-md-space-between align-md-center">
					<b>{{ item.address }}</b>

					<span>
						<span
							v-if="item.defaultStructure"
							class="d-none d-md-block text-right ap-blue--text text--darken-1 font-weight-semibold"
						>
							{{ locales.defaultStructure }}
						</span>

						{{ locales.label }} {{ item.idNumber }}
					</span>
				</span>
			</span>
		</span>
	</label>
</template>

<script setup lang="ts">
	import { PropType, computed, ref } from 'vue';
	import AmeliproIcon from '../AmeliproIcon/AmeliproIcon.vue';
	import { IndexedObject } from '../../types';
	import { Structure } from './types';
	import { convertToHex } from '../../functions/convertToHex';
	import { locales } from './locales';

	const props = defineProps({
		checked: {
			type: Boolean,
			default: false,
		},
		groupName: {
			type: String,
			required: true,
		},
		item: {
			type: Object as PropType<Structure>,
			required: true,
		},
		optionName: {
			type: String,
			required: true,
		},
		outlineColor: {
			type: String,
			default: 'ap-black',
		},
	});

	const focused = ref(false);
	const focusStyle = computed<IndexedObject | undefined>(() => (focused.value ? { outline: `1px dotted ${convertToHex(props.outlineColor)}` } : undefined));
	const ariaCheckedValue = computed<'true' | 'false'>(() => {
		if (props.checked) {
			return 'true';
		}
		return 'false';
	});
	const emit = defineEmits(['select']);

	const emitEvent = (): void => {
		emit('select', props.item.value);
	};

</script>

<style lang="scss" scoped>
	input {
		position: absolute;
		width: 0;
		height: 0;
		opacity: 0;
	}

	.item-rounded {
		border-radius: 8px;
	}

	.hover-style {

		&:hover {
			background-color: $ap-blue-lighten3 !important;
		}
	}

	.selected-border {
		border: 1px solid $ap-blue;
	}
</style>
